import React, { useState, useCallback } from "react";
import { LandingHeader, scrollToId } from "@/components/landing/LandingHeader";
import { LandingHero } from "@/components/landing/LandingHero";
import { Showcase } from "@/components/landing/Showcase";
import { Directory } from "@/components/landing/Directory";
import { Features } from "@/components/landing/Features";
import { Pricing } from "@/components/landing/Pricing";
import { FinalCta, LandingFooter } from "@/components/landing/FinalCta";

export default function Landing() {
  const [mode, setMode] = useState("register");
  const [next, setNext] = useState({ tab: "", name: "" });

  const openAuth = useCallback((m, tab = "", name = "") => {
    setMode(m);
    setNext({ tab, name });
    scrollToId("access");
    setTimeout(() => document.querySelector('[data-testid="auth-email"]')?.focus({ preventScroll: true }), 450);
  }, []);
  const onFree = () => openAuth("register");
  const onSignIn = () => openAuth("login");
  const onOpen = (tab, name) => openAuth("login", tab, name);

  return (
    <div data-testid="landing-page" className="dark min-h-screen overflow-x-hidden bg-[#03050A] text-slate-200 selection:bg-[#22D3EE] selection:text-slate-950">
      <LandingHeader onSignIn={onSignIn} onFree={onFree} />
      <main>
        <LandingHero mode={mode} setMode={setMode} nextTab={next.tab} nextName={next.name} onFree={onFree} />
        <Showcase onOpen={onOpen} />
        <Directory onOpen={onOpen} />
        <Features />
        <Pricing onFree={onFree} onSignIn={onSignIn} />
        <FinalCta onFree={onFree} />
      </main>
      <LandingFooter onSignIn={onSignIn} onOpen={onOpen} />
    </div>
  );
}
